module.exports = __webpack_public_path__ + "img/apply.6949760c.svg";